// Mock data for Industrial Valves E-commerce Website

export const heroSlides = [
  {
    id: 1,
    title: "شیر آلات صنعتی با کیفیت برتر",
    subtitle: "تامین کننده تجهیزات لوله کشی و شیر آلات",
    cta: "مشاهده محصولات",
    bgColor: "#f8f9fa"
  },
  {
    id: 2,
    title: "لوله و اتصالات فلزی",
    subtitle: "انواع لوله و اتصالات صنعتی با استاندارد جهانی",
    cta: "سفارش آنلاین",
    bgColor: "#e8f4f8"
  },
  {
    id: 3,
    title: "تجهیزات سیستم های صنعتی",
    subtitle: "ارسال به سراسر کشور با بهترین قیمت",
    cta: "تماس با ما",
    bgColor: "#f0f0f0"
  }
];

export const brandLogos = [
  { id: 1, name: "میراب", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=Mirab" },
  { id: 2, name: "بنکن", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=Benkan" },
  { id: 3, name: "وگ ایران", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=Vog" },
  { id: 4, name: "فاراب", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=Farab" },
  { id: 5, name: "نیوپایپ", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=NewPipe" },
  { id: 6, name: "سوپرپایپ", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=SuperPipe" },
  { id: 7, name: "پلیران", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=Peliran" },
  { id: 8, name: "شیلان", logo: "https://via.placeholder.com/120x60/005bbb/ffffff?text=Shilan" }
];

export const featuredCategories = [
  { id: 1, name: "پارس پایپینگ", icon: "Gauge", count: 245 },
  { id: 2, name: "لوله فلزی", icon: "Pipe", count: 189 },
  { id: 3, name: "اتصالات فلزی", icon: "Plug", count: 312 },
  { id: 4, name: "فلنج و اتصالات", icon: "Circle", count: 156 },
  { id: 5, name: "لوله پلیمری", icon: "Cable", count: 203 },
  { id: 6, name: "تجهیزات آتش نشانی", icon: "Flame", count: 98 }
];

export const pipeSystemCategories = [
  {
    id: 1,
    name: "لوله مانیسمان",
    subcategories: [
      "لوله مانیسمان رده 40",
      "لوله مانیسمان رده 80",
      "لوله مانیسمان رده 160"
    ]
  },
  {
    id: 2,
    name: "لوله گالوانیزه",
    subcategories: [
      "لوله گالوانیزه سنگین",
      "لوله گالوانیزه نیمه سنگین",
      "لوله گالوانیزه سبک"
    ]
  },
  {
    id: 3,
    name: "اتصالات جوشی",
    subcategories: [
      "سه راه جوشی",
      "زانو جوشی",
      "تبدیل جوشی"
    ]
  },
  {
    id: 4,
    name: "فلنج فولادی",
    subcategories: [
      "فلنج جوشی",
      "فلنج دنده ای",
      "فلنج کور"
    ]
  },
  {
    id: 5,
    name: "شیرآلات برنجی",
    subcategories: [
      "شیر سوزنی",
      "شیر توپی",
      "شیر یکطرفه"
    ]
  },
  {
    id: 6,
    name: "لوله پلی اتیلن",
    subcategories: [
      "لوله PE80",
      "لوله PE100",
      "اتصالات پلی اتیلن"
    ]
  }
];

export const allBrands = [
  { id: 1, name: "میراب" },
  { id: 2, name: "بنکن" },
  { id: 3, name: "وگ ایران" },
  { id: 4, name: "فاراب" },
  { id: 5, name: "نیوپایپ" },
  { id: 6, name: "سوپرپایپ" },
  { id: 7, name: "پلیران" },
  { id: 8, name: "شیلان" },
  { id: 9, name: "کیز ایران" },
  { id: 10, name: "ساوه" },
  { id: 11, name: "توپی" },
  { id: 12, name: "ارتعاشات صنعتی" },
  { id: 13, name: "گلرنگ" },
  { id: 14, name: "ایران مال" },
  { id: 15, name: "بانک آینده" },
  { id: 16, name: "سایپا" },
  { id: 17, name: "بانک سامان" },
  { id: 18, name: "فکور صنعت" },
  { id: 19, name: "وزان" },
  { id: 20, name: "بیمه رازی" },
  { id: 21, name: "برند ۲۱" },
  { id: 22, name: "برند ۲۲" },
  { id: 23, name: "برند ۲۳" },
  { id: 24, name: "برند ۲۴" },
  { id: 25, name: "برند ۲۵" },
  { id: 26, name: "برند ۲۶" },
  { id: 27, name: "برند ۲۷" },
  { id: 28, name: "برند ۲۸" },
  { id: 29, name: "برند ۲۹" },
  { id: 30, name: "برند ۳۰" },
  { id: 31, name: "برند ۳۱" },
  { id: 32, name: "برند ۳۲" },
  { id: 33, name: "برند ۳۳" },
  { id: 34, name: "برند ۳۴" },
  { id: 35, name: "برند ۳۵" },
  { id: 36, name: "برند ۳۶" },
  { id: 37, name: "برند ۳۷" },
  { id: 38, name: "برند ۳۸" },
  { id: 39, name: "برند ۳۹" },
  { id: 40, name: "برند ۴۰" },
  { id: 41, name: "برند ۴۱" },
  { id: 42, name: "برند ۴۲" },
  { id: 43, name: "برند ۴۳" },
  { id: 44, name: "برند ۴۴" },
  { id: 45, name: "برند ۴۵" },
  { id: 46, name: "برند ۴۶" },
  { id: 47, name: "برند ۴۷" },
  { id: 48, name: "برند ۴۸" },
  { id: 49, name: "برند ۴۹" },
  { id: 50, name: "برند ۵۰" }
];

export const customers = [
  { id: 1, name: "بانک آینده", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Bank" },
  { id: 2, name: "ایران مال", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=IranMall" },
  { id: 3, name: "بیمه رازی", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Razi" },
  { id: 4, name: "گروه صنعتی گلرنگ", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Golrang" },
  { id: 5, name: "فکور صنعت", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Fekur" },
  { id: 6, name: "شرکت وزان", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Vazan" },
  { id: 7, name: "توسعه سایپا", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Saipa" },
  { id: 8, name: "بانک سامان", logo: "https://via.placeholder.com/150x80/005bbb/ffffff?text=Saman" }
];

export const purchaseSteps = [
  {
    id: 1,
    title: "ثبت لیست خرید",
    description: "بارگذاری لیست یا انتخاب از سایت",
    icon: "ClipboardList"
  },
  {
    id: 2,
    title: "صدور پیش فاکتور",
    description: "ارسال قیمت نهایی توسط کارشناسان",
    icon: "FileText"
  },
  {
    id: 3,
    title: "تایید و پرداخت",
    description: "تایید پیش فاکتور و روش پرداخت",
    icon: "CreditCard"
  },
  {
    id: 4,
    title: "ارسال بار",
    description: "ارسال به سراسر کشور",
    icon: "Truck"
  }
];

export const mainCategories = [
  {
    id: 1,
    name: "لوله فلزی",
    icon: "Pipe",
    subcategories: [
      "لوله مانیسمان رده 40",
      "لوله مانیسمان رده 80",
      "لوله سیاه درزدار",
      "لوله گالوانیزه سنگین",
      "لوله استیل",
      "لوله مسی",
      "لوله کشاورزی"
    ]
  },
  {
    id: 2,
    name: "اتصالات فلزی",
    icon: "Plug",
    subcategories: [
      "سه راه جوشی",
      "زانو جوشی",
      "تبدیل جوشی",
      "سردنده",
      "چهارراه",
      "بوشن"
    ]
  },
  {
    id: 3,
    name: "فلنج و اتصالات",
    icon: "Circle",
    subcategories: [
      "فلنج جوشی",
      "فلنج دنده ای",
      "فلنج کور",
      "واشر",
      "گسکت",
      "پیچ و مهره"
    ]
  },
  {
    id: 4,
    name: "پارس پایپینگ",
    icon: "Gauge",
    subcategories: [
      "شیر توپی",
      "شیر کشویی",
      "شیر سوزنی",
      "شیر یکطرفه",
      "شیر فشار شکن"
    ]
  },
  {
    id: 5,
    name: "لوله پلیمری",
    icon: "Cable",
    subcategories: [
      "لوله پنج لایه",
      "لوله تک لایه",
      "لوله پلی اتیلن",
      "اتصالات پلیمری",
      "لوله PVC"
    ]
  },
  {
    id: 6,
    name: "سیستم اطفاء حریق",
    icon: "Flame",
    subcategories: [
      "تجهیزات آتش نشانی",
      "شیرآلات آتش نشانی",
      "نازل آتش نشانی"
    ]
  },
  {
    id: 7,
    name: "لرزه گیر صنعتی",
    icon: "Activity",
    subcategories: [
      "لرزه گیر لاستیکی",
      "لرزه گیر آکاردئونی"
    ]
  },
  {
    id: 8,
    name: "ابزار دقیق",
    icon: "Wrench",
    subcategories: [
      "مانومتر",
      "ترمومتر",
      "شیر سماوری"
    ]
  },
  {
    id: 9,
    name: "عایق لوله",
    icon: "Shield",
    subcategories: [
      "عایق الاستومری",
      "عایق فومی",
      "عایق رولی"
    ]
  },
  {
    id: 10,
    name: "بست و نگهدارنده",
    icon: "Anchor",
    subcategories: [
      "بست لوله",
      "بست آویز",
      "بست دیواری"
    ]
  },
  {
    id: 11,
    name: "شلنگ صنعتی",
    icon: "Cable",
    subcategories: [
      "شلنگ پکیج",
      "شلنگ فن کویل"
    ]
  },
  {
    id: 12,
    name: "ابزار لوله کشی",
    icon: "Wrench",
    subcategories: [
      "الکترود",
      "چسب",
      "نوار"
    ]
  }
];

// دسته‌بندی‌های داشبورد با ساختار مورد نیاز صفحه CategoryPage
export const dashboardCategories = [
  // سطح ۱ – دسته اصلی
  {
    id: 100,
    slug: "industrial-valves", // آدرسی که در URL استفاده می‌کنیم
    title: "پارس پایپینگ",
    level: 1,
    parentId: null,
    subtitle: "انواع پارس پایپینگ برای خطوط لوله و تاسیسات",
    description:
      "در این بخش انواع پارس پایپینگ شامل شیر توپی، کشویی، سوزنی و یکطرفه را می‌توانید مشاهده کنید. تمام محصولات از برندهای معتبر و با استانداردهای بین‌المللی تامین می‌شوند.",
    features: [
      "مناسب برای خطوط بخار، آب، گاز و سیالات صنعتی",
      "قابلیت تحمل فشار و دمای بالا",
      "تنوع سایز از ۱/۲ تا ۲۰ اینچ"
    ],
    faqs: [
      {
        id: 1,
        question: "چه نوع شیرآلاتی برای سیستم‌های حرارتی مناسب هستند؟",
        answer:
          "معمولاً شیرآلات برنجی و فولادی با تحمل دمای بالا برای سیستم‌های حرارتی استفاده می‌شوند."
      },
      {
        id: 2,
        question: "آیا امکان مشاوره قبل از خرید وجود دارد؟",
        answer:
          "بله، کارشناسان فنی ما آماده راهنمایی شما در انتخاب شیرآلات مناسب پروژه شما هستند."
      }
    ],
    // این‌ها id برندهایی هستند که می‌خواهی پایین صفحه نمایش داده شوند
    brandIds: [1, 2, 3, 4]
  },

  // سطح ۲ – زیرمجموعه‌های همین دسته اصلی
  {
    id: 101,
    slug: "ball-valves",
    title: "شیر توپی",
    level: 2,
    parentId: 100,
    shortDescription: "انواع شیر توپی فولادی و برنجی برای مصارف صنعتی و ساختمانی"
  },
  {
    id: 102,
    slug: "gate-valves",
    title: "شیر کشویی",
    level: 2,
    parentId: 100,
    shortDescription: "شیر کشویی فلزی مناسب برای خطوط اصلی آب و بخار"
  },
  {
    id: 103,
    slug: "check-valves",
    title: "شیر یکطرفه",
    level: 2,
    parentId: 100,
    shortDescription: "جلوگیری از برگشت سیال در خطوط لوله"
  }
];


export const aboutCompany = {
  title: "درباره شرکت",
  description: "ما با بیش از ۱۵ سال تجربه در زمینه تامین و توزیع تجهیزات صنعتی، ساختمانی و تاسیساتی، به عنوان یکی از بزرگترین مراکز تخصصی در ایران فعالیت می‌کنیم. تامین محصولات با کیفیت، قیمت رقابتی و ارسال سریع از اولویت‌های ماست.",
  features: [
    { title: "تنوع محصولات", description: "بیش از ۱۰۰۰۰ قلم کالا" },
    { title: "کیفیت تضمینی", description: "محصولات با استاندارد بین‌المللی" },
    { title: "قیمت مناسب", description: "بهترین قیمت بازار" },
    { title: "ارسال سریع", description: "ارسال به سراسر کشور" }
  ]
};
